import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum DepositFormErrorStatesEnum {
    GetClientFailed = ErrorStateScheduleEnum.DepositFormStatesStartIndex,
    RegisterBankDepositFailed,
    RegisterInternalDepositFailed,
    CanFindCorrectPaymentMethod,
    GetDefaultVendorBankAccountFailed,
    DefaultVendorBankAccountNotFound
}
